import Entity from './entity'

export default class Dictionary extends Entity<string>{
    value: string;
    dictionaryTypeId: string;
    description:string;
}